import { CaseReducer, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AggregateStatusResponseModel } from 'data/result/result.model';

type SliceState = {
  status: 'idle' | 'loading' | 'data' | 'error';
  data: AggregateStatusResponseModel;
  error: any;
};

const initState: SliceState = {
  status: 'idle',
  data: {
    id: '',
    final_exams: [],
    terminal_exams: [],
    test_types: [],
  },
  error: false,
};

const setLoading = (): SliceState => ({ ...initState, status: 'loading' });

const setData: CaseReducer<SliceState, PayloadAction<AggregateStatusResponseModel>> = (
  _,
  action,
) => ({
  error: false,
  data: action.payload,
  status: 'data',
});

const setError: CaseReducer<SliceState, PayloadAction<any>> = (state, action) => ({
  error: action.payload,
  data: initState.data,
  status: 'error',
});

const resultAggregationStatusSlice = createSlice({
  name: 'resultAggregationStatus',
  initialState: initState,
  reducers: {
    setLoading,
    setData,
    setError,
  },
});

export default resultAggregationStatusSlice;
